// src/pages/ResetPage.tsx
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { authApi } from "../lib/auth-api";
import { AuthLayout, Field } from "./LoginPage";

export function ResetPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) { setError("token がありません"); return; }
    if (password !== confirm) { setError("パスワードが一致しません"); return; }
    if (password.length < 8) { setError("パスワードは 8 文字以上で設定してください"); return; }
    setBusy(true); setError(null);
    try {
      const r = await authApi.reset({ token, password });
      setDone(r.message);
    } catch (err) {
      setError((err as Error).message);
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <AuthLayout title="パスワード再設定 完了">
        <p className="text-sm text-slate-700">{done}</p>
        <div className="mt-5 text-center text-sm">
          <Link to="/login" className="text-blue-700 hover:underline">ログインへ →</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="パスワードを再設定">
      <form onSubmit={onSubmit} className="space-y-3">
        <Field label="新しいパスワード (8 文字以上)">
          <input
            type="password" autoComplete="new-password" required minLength={8} value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="auth-input"
          />
        </Field>
        <Field label="新しいパスワード (確認)">
          <input
            type="password" autoComplete="new-password" required minLength={8} value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="auth-input"
          />
        </Field>
        {error && <div className="auth-error">{error}</div>}
        <button type="submit" disabled={busy} className="auth-button">
          {busy ? "更新中…" : "パスワードを更新"}
        </button>
      </form>
    </AuthLayout>
  );
}
